import { render } from "./CurrencyInput.vue?vue&type=template&id=1b49a090&scoped=true&ts=true"
import script from "./CurrencyInput.vue?vue&type=script&lang=ts"
export * from "./CurrencyInput.vue?vue&type=script&lang=ts"

import "./CurrencyInput.vue?vue&type=style&index=0&id=1b49a090&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b49a090"]])

export default __exports__